
// import React, { useEffect, useState } from "react";
// import { Routes, Route, Link } from "react-router-dom";
// import MainPage from "./pages/MainPage";
// import InpaintingPage from "./pages/inpaintingpage";
// import FurnishingPage from "./pages/FurnishingPage";
// import "./App1.css";
// import Login from "./components/login";
// import Signup from "./components/Signup";
// import ExploreToolsPage from "./pages/ToolsSection";
// // import { onAuthStateChanged } from "firebase/auth";
// // import { auth } from "./components/firebase";

// function App() {
//   const [menuActive, setMenuActive] = useState(false);
//   // const [user, setUser] = useState(null);

//   // useEffect(() => {
//   //   const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
//   //     if (firebaseUser) {
//   //       setUser(firebaseUser);
//   //       console.log("User is logged in:", firebaseUser.email);
//   //     } else {
//   //       setUser(null);
//   //       console.log("No user logged in");
//   //     }
//   //   });

//   //   return () => unsubscribe();
//   // }, []);

//   const toggleMenu = () => {
//     setMenuActive(!menuActive);
//   };

//   useEffect(() => {
//     const navbar = document.querySelector(".navbarhome");
//     const handleScroll = () => {
//       if (window.scrollY > 50) {
//         navbar.classList.add("sticky");
//       } else {
//         navbar.classList.remove("sticky");
//       }
//     };
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   return (
//     <Routes>
//       <Route path="/" element={
//         <div className="home-wrapper">
//           <header className="navbarhome">
//             <h1>
//               <a href="/#home" className="logo">RevampSpaces</a>
//             </h1>
//             <div className={`navbar-links ${menuActive ? 'active' : ''}`}>
//               <a href="/#about" className="nav-link" onClick={() => setMenuActive(false)}>About Us</a>
//               <a href="/#contact" className="nav-link" onClick={() => setMenuActive(false)}>Contact Us</a>
//               <Link to="/login" className="nav-link" onClick={() => setMenuActive(false)}>Login</Link>
//             </div>
//             <div className={`hamburger ${menuActive ? 'active' : ''}`} onClick={toggleMenu}>
//               <span></span>
//               <span></span>
//               <span></span>
//             </div>
//           </header>
//           <HomePage />
//         </div>
//       } />
//       <Route path="/main" element={<MainPage />} />
//       <Route path="/inpainting" element={<InpaintingPage />} />
//       <Route path="/furnish" element={<FurnishingPage />} />
//       <Route path="/signup" element={<Signup />} />
//       <Route path="/login" element={<Login />} />
//       <Route path="/tools" element={<ExploreToolsPage />} />
//     </Routes>
//   );
// }

// function HomePage() {
//   return (
//     <div className="homepage" id="home">
//       {/* Hero Section */}
//       <header className="hero" style={{ 
//         backgroundImage: `url(${process.env.PUBLIC_URL}/images/backimg2.png)`,
//         backgroundSize: 'cover', 
//         backgroundPosition: 'center' 
//       }}>
//         <div className="hero-content">
//           <div className="hero-card">
//             <h1>Revamp Your Space with AI</h1>
//             <p>Transform your interiors effortlessly with AI-powered design tools.</p>
//             <Link to="/login" className="cta-button">Get Started</Link>
//           </div>
//         </div>
//       </header>

//       {/* Why Choose Us Section */}
//       <section className="why-choose-us">
//           {/* <div className="animated-bg">
//             <div className="circle circle1"></div>
//             <div className="circle circle2"></div>
//             <div className="circle circle3"></div>
//             <div className="circle circle4"></div>
//             <div className="circle circle5"></div>
//             <div className="circles circles1"></div>
//             <div className="circless circles2"></div>
//           </div> */}

//           <h2>Why Choose RevampSpaces?</h2>
//           <h3>Intelligent. Seamless. Affordable. Your dream space is just a click away.</h3>
//           <div className="card-container">
//             <div className="card">
//               <h3>AI-Powered Precision</h3>
//               <p>Our advanced AI understands spatial aesthetics, color harmony, and design principles—delivering interiors that feel expertly curated. Every generated space is crafted with precision, ensuring a seamless blend of beauty and functionality</p>
//             </div>
//             <div className="card">
//               <h3>Quick & Easy</h3>
//               <p>No design expertise? No problem. Our platform is built for everyone—just upload, select, and transform. With an intuitive interface and smart automation, creating breathtaking interiors has never been easier.</p>
//             </div>
//             <div className="card">
//               <h3>Budget-Friendly</h3>
//               <p>Great design shouldn't come with a hefty price tag. Whether you're exploring concepts or finalizing a vision, RevampSpaces helps you achieve stunning interiors without overspending. Experience high-end aesthetics tailored to your budget.</p>
//             </div>
//           </div>
//       </section>

//       {/* About Section */}
//       <section id="about" className="about-section">
//         {/* <div className="animated-bgas">
//             <div className="circlesas circles1as"></div>
//             <div className="circlessas circles2as"></div>
//         </div> */}
//         <div className="about-container">
//           <div className="about-text">
//             <h2>About Us</h2>
//             <p>
//               At <strong>RevampSpaces</strong>, we believe that interior design should be effortless, 
//               accessible, and inspiring. Our AI-powered platform transforms the way you design your space, 
//               allowing you to visualize stunning interiors with just a few clicks. 
//             </p>
//             <p>
//               Whether you're refreshing a single room or revamping your entire home, 
//               our intelligent tools generate personalized designs tailored to your style and preferences.  
//             </p>
//           </div>
//           <div className="about-image">
//             {/* <img src={`${process.env.PUBLIC_URL}/images/farmhouse.png`} alt="About Us" /> */}
//             <video 
//                src={`${process.env.PUBLIC_URL}/videos/about.mp4`} 
//                autoPlay 
//                loop 
//                muted 
//                playsInline
//                className="about-video"
//             />
//           </div>
//         </div>
//       </section>

//       <section className="gallery">
//         {/* <div className="animated-bggi">
//             <div className="circlesgi circles1gi"></div>
//         </div> */}
//         <h2>Our Generated Images</h2>
//         <div className="gallery-container">
//           <div className="gallery-track">
//             <img src={`${process.env.PUBLIC_URL}/images/image1.png`} alt="Gallery Image 1"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image2.png`} alt="Gallery Image 2"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image3.png`} alt="Gallery Image 3"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image4.png`} alt="Gallery Image 4"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image5.png`} alt="Gallery Image 5"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image1.png`} alt="Gallery Image 1"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image2.png`} alt="Gallery Image 2"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image3.png`} alt="Gallery Image 3"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image4.png`} alt="Gallery Image 4"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image5.png`} alt="Gallery Image 5"/>
//           </div>
//         </div>
//       </section>

//       <section className="gallery2">
//         {/* <div className="animated-bggii">
//             <div className="circlesgii circles1gii"></div>
//         </div> */}
//         <div className="gallery-container2">
//           <div className="gallery-track2">
//             <img src={`${process.env.PUBLIC_URL}/images/image6.png`} alt="Gallery Image 6"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image7.png`} alt="Gallery Image 7"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image8.png`} alt="Gallery Image 8"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image9.png`} alt="Gallery Image 9"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image10.png`} alt="Gallery Image 10"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image11.png`} alt="Gallery Image 11"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image12.png`} alt="Gallery Image 12"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image6.png`} alt="Gallery Image 6"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image7.png`} alt="Gallery Image 7"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image8.png`} alt="Gallery Image 8"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image9.png`} alt="Gallery Image 9"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image10.png`} alt="Gallery Image 10"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image11.png`} alt="Gallery Image 11"/>
//             <img src={`${process.env.PUBLIC_URL}/images/image12.png`} alt="Gallery Image 12"/>
//           </div>
//         </div>
//       </section>

//       {/* Types of Images We Work With Section */}
//       <section className="image-types">
//         {/* <div className="animated-bgit">
//             <div className="circleit circle1it"></div>
//             <div className="circleit circle2it"></div>
//             <div className="circleit circle3it"></div>
//             <div className="circleit circle4it"></div>
//             <div className="circleit circle5it"></div>
//             <div className="circlesit circles1it"></div>
//             <div className="circlessit circles2it"></div>
//         </div> */}
//         <h2>Visualization Made Easy </h2>
//         <div className="image-grid">
//           <div className="image-card">
//             <div className="hover-image">
//               <img src={`${process.env.PUBLIC_URL}/images/livingroom1.jpg`} alt="Simple Room Before" className="before" />
//               <img src={`${process.env.PUBLIC_URL}/images/livingroom.png`} alt="Simple Room After" className="after" />
//             </div>
//             <div className="card-content">
//               <h3>Revamp Your Space With A Click</h3>
//               <p>Imagine capturing a photo of your room and instantly exploring a world of design possibilities. At RevampSpaces, we bring your interiors to life with the power of AI. Simply upload an image of your space, and our advanced technology will generate stunning redesigns tailored to your preferred style—whether it's modern minimalism, cozy Scandinavian, or luxurious contemporary.</p>
//             </div>
//           </div>

//           <div className="image-card">
//             <div className="hover-image">
//               <img src={`${process.env.PUBLIC_URL}/images/bathroom.jpg`} alt="Sketch Before" className="before" />
//               <img src={`${process.env.PUBLIC_URL}/images/bathroom1.png`} alt="Sketch After" className="after" />
//             </div>
//             <div className="card-content">
//               <h3>From Sketch to Stunning Interior</h3>
//               <p>A simple sketch is all it takes to bring your vision to life. With RevampSpaces, transform hand-drawn layouts into beautifully designed interiors in seconds. Whether it's a rough outline or a detailed floor plan, our AI interprets your ideas and reimagines them in breathtaking styles.</p>
//             </div>
//           </div>

//           <div className="image-card">
//             <div className="hover-image">
//               <img src={`${process.env.PUBLIC_URL}/images/tvpanel1.png`} alt="3D Model Before" className="before" />
//               <img src={`${process.env.PUBLIC_URL}/images/tvpanel.png`} alt="3D Model After" className="after" />
//             </div>
//             <div className="card-content">
//               <h3>From 3D Model to Breathtaking Design</h3>
//               <p>Bring your 3D models to life with stunning interior designs. At RevampSpaces, our AI transforms basic 3D layouts into fully styled, photorealistic interiors. Simply upload your model, select a theme, and watch as your space evolves with elegance and precision.</p>
//             </div>
//           </div>

//           <div className="image-card">
//             <div className="hover-image">
//               <img src={`${process.env.PUBLIC_URL}/images/emptyroom.png`} alt="Simple Room Before" className="before" />
//               <img src={`${process.env.PUBLIC_URL}/images/emptyroom1.png`} alt="Simple Room After" className="after" />
//             </div>
//             <div className="card-content">
//               <h3>Turn bare walls into beautiful homes—one piece at a time.</h3>
//               <p>An empty room is a canvas full of possibilities. With RevampSpaces, effortlessly fill your space with carefully curated furniture and decor, perfectly tailored to your style. From sleek modern aesthetics to timeless classics, our AI places each piece with harmony and precision—transforming emptiness into elegance.</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Do It Yourself */}
//       <div className="how-it-works">
//         {/* <div className="animated-bghiw">
//             <div className="circlehiw circle1hiw"></div>
//             <div className="circlehiw circle2hiw"></div>
//             <div className="circlehiw circle3hiw"></div>
//             <div className="circlehiw circle4hiw"></div>
//             <div className="circlehiw circle5hiw"></div>
//             <div className="circleshiw circles1hiw"></div>
//             <div className="circlesshiw circles2hiw"></div>
//         </div> */}
//         <h2>Do It Yourself</h2>
//         <div className="card-container">
//           <div className="card">
//             <h3>Step 1: Upload Your Room</h3>
//             <p>Simply upload a picture of your room, and we'll take care of the rest!</p>
//             <img src={`${process.env.PUBLIC_URL}/images/uploadicon.png`} alt="Upload Icon" className="before" />
//           </div>
//           <div className="card">
//             <h3>Step 2: Select Your Style</h3>
//             <p>Choose your favorite interior design style and let us create the perfect look for you.</p>
//             <img src={`${process.env.PUBLIC_URL}/images/styles.png`} alt="Style Selection" className="before" />
//             <img src={`${process.env.PUBLIC_URL}/images/rooms.png`} alt="Room Types" className="after" />
//           </div>
//           <div className="card">
//             <h3>Step 3: Receive Your Design</h3>
//             <p>Get your personalized design suggestions, ready to transform your space!</p>
//             <img src={`${process.env.PUBLIC_URL}/images/bedroom.png`} alt="Bedroom Design" className="after" />
//           </div>
//         </div>
//       </div>

//       <section className="upcoming-tools">
//         {/* <div className="animated-bgut">
//             <div className="circleut circle1ut"></div>
//             <div className="circleut circle2ut"></div>
//             <div className="circleut circle3ut"></div>
//             <div className="circleut circle4ut"></div>
//             <div className="circleut circle5ut"></div>
//             <div className="circlesut circles1ut"></div>
//             <div className="circlessut circles2ut"></div>
//         </div> */}
//         <h2>Upcoming Tools</h2>
//         <div className="card-container">
//           <div className="image-card">
//             <div className="hover-image">
//               <img src={`${process.env.PUBLIC_URL}/images/2dfloorplan.png`} alt="Simple Room Before" className="before" />
//               <img src={`${process.env.PUBLIC_URL}/images/3dfloorplan.jpg`} alt="Simple Room After" className="after" />
//             </div>
//             <div className="card-content">
//               <h3>From 2D Plans to 3D Spaces In Minutes</h3>
//               <h4>Visualize Before You Create.</h4>
//               <p>Transform your 2D floor plans into simple, structured 3D models with ease. At RevampSpaces, we bridge the gap between sketches and stunning interiors by generating basic 3D layouts that serve as the foundation for AI-powered design transformations.</p>
//             </div>
//           </div>

//           <div className="image-card">
//             <div className="hover-image">
//               <img src={`${process.env.PUBLIC_URL}/images/theme1.png`} alt="Simple Room Before" className="before" />
//               <img src={`${process.env.PUBLIC_URL}/images/theme2.png`} alt="Simple Room After" className="after" />
//             </div>
//             <div className="card-content">
//               <h3>Bespoke AI Models, Tailored to Your Vision</h3>
//               <h4>Your Style. Your AI. Your Legacy.</h4>
//               <p>At RevampSpaces, we offer an exclusive service for designers, brands, and artists looking to train AI models on their unique design styles. Whether you're an interior designer, an architect, or a creative visionary, our AI can learn from your work—capturing your signature aesthetic and transforming it into a tool that scales your creativity.</p>
//             </div>
//           </div>

//           <div className="image-card">
//             <div className="hover-image">
//               <img src={`${process.env.PUBLIC_URL}/images/bedroom_chair0.png`} alt="Sketch Before" className="before" />
//               <img src={`${process.env.PUBLIC_URL}/images/bedroom_chair2.png`} alt="Sketch After" className="after" />
//             </div>
//             <div className="card-content">
//               <h3>Experience the Future of Interior Shopping</h3>
//               <h4>See it. Style it. Shop it.</h4>
//               <p>At RevampSpaces, we're not just transforming interiors—we're revolutionizing the way you shop for furniture. Soon, our platform will evolve into a dynamic marketplace, where you can generate and visualize furniture from nearby stores directly in your space.</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Pricing Section */}
//       {/* <section id="pricing" className="pricing"> */}
//       {/* <div className="animated-bgp">
//             <div className="circlessp circles2p"></div>
//         </div> */}
//         {/* <h2>Pricing</h2>
//         <div className="price-card">
//           <h3>Basic (5 credits)</h3>
//           <p>Free for 5 image generations</p>
//           <p>Get basic AI-generated designs.</p>
//           <p>Only image generations</p>
//           <div className="comingsoon">
//             <h3>Coming Soon</h3>
//           </div>
//         </div>
//         <div className="price-card">
//           <h3>Weekly</h3>
//           <p>600/week (150 credits) </p>
//           <p>For a week you can generate upto 150 images</p>
//           <p>Only image generations</p>
//           <div className="comingsoon">
//             <h3>Coming Soon</h3>
//           </div>
//         </div>
//         <div className="price-card">
//           <h3>Monthly</h3>
//           <p>2000/month (500 credits) </p>
//           <p>for a Month you can generate 500 images</p>
//           <p>Only image generations</p>
//           <div className="comingsoon">
//             <h3>Coming Soon</h3>
//           </div>
//         </div>
//         <div className="price-card">
//           <h3>Pro</h3>
//           <p>5000/month (1000 credits) </p>
//           <p>for a Month you can generate 1000 images</p>
//           <p>Access to all tools</p>
//           <div className="comingsoon">
//             <h3>Coming Soon</h3>
//           </div>
//         </div>
//       </section> */}

//       {/* FAQ Section */}
//       {/* <section id="faq" className="faq">
//       <div className="animated-bgfaq">
//             <div className="circlessfaq circles2faq"></div>
//         </div>
//         <h2>Frequently Asked Questions</h2>
//         <div className="faq-item">
//           <h3>How does it work?</h3>
//           <p>Upload a photo, select a style, and receive a design.</p>
//         </div>
//         <div className="faq-item">
//           <h3>Is it free to use?</h3>
//           <p>We offer a free basic version and a paid pro plan.</p>
//         </div>
//       </section> */}
//       <section id="faq" className="faq-section">
//   <h2>Frequently Asked Questions</h2>
//   <div className="faq-container">
//     <div className="faq-item">
//       <button className="faq-question">What is RevampSpaces?<span className="faq-icon">+</span></button>
//       <div className="faq-answer">
//         <p>RevampSpaces is an AI-powered interior design platform that helps you transform your rooms into beautifully designed spaces with just a few clicks.</p>
//       </div>
//     </div>

//     <div className="faq-item">
//       <button className="faq-question">How can RevampSpaces help my business?<span className="faq-icon">+</span></button>
//       <div className="faq-answer">
//         <p>Our platform enables interior designers, architects, and homeowners to visualize ideas instantly, helping professionals save time and boost creativity while improving client satisfaction.</p>
//       </div>
//     </div>

//     <div className="faq-item">
//       <button className="faq-question">How many products or tools does RevampSpaces offer?<span className="faq-icon">+</span></button>
//       <div className="faq-answer">
//         <p>We currently offer AI-powered image generation tools like Room Revamp, Inpainting, and Furnishing. More tools such as AI-trained design models and 3D visualization are coming soon.</p>
//       </div>
//     </div>
//   </div>
// </section>

      



//       {/* Contact Section */}
//       <section id="contact" className="contact">
//       {/* <div className="animated-bgc">
//         <div className="circlessc circles2c"></div>
//       </div> */}
//        <h2>Contact Us</h2>
//        <p>Email: revampspaces.in@gmail.com</p>
//         <div className="social-links">
//          <a href="https://www.instagram.com/revampspaces.in" target="_blank" rel="noopener noreferrer">
//           <img src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png" alt="Instagram" className="social-icon" />
//          </a>
//         </div>
//       </section>

//       {/* Footer Section */}
//       <footer className="footer-section">
//   <div className="footer-content">
//     <div className="footer-about">
//       <img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="RevampSpaces Logo" className="footer-logo" />
//       <p>We are building revolutionary software to help interior designers and homeowners visualize their creative design ideas with ease and accuracy.</p>
//       <div className="footer-socials">
//         <a href="https://www.instagram.com/revampspaces.in" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
//         <a href="#"><i className="fab fa-linkedin"></i></a>
//         <a href="#"><i className="fab fa-facebook"></i></a>
//         <a href="#"><i className="fab fa-youtube"></i></a>
//       </div>
//     </div>

//     <div className="footer-links">
//       <h4>Links</h4>
//       <ul>
//         <li><a href="/#home">Home</a></li>
//         <li><a href="/#about">About Us</a></li>
//         <li><Link to="/tools">Try Now</Link></li>
//         <li><a href="/#contact">Contact Us</a></li>
//         <li><Link to="/login">Log In</Link></li>
//       </ul>
//     </div>

//     <div className="footer-other">
//       <h4>Other</h4>
//       <ul>
//         <li><a href="#">Terms & Conditions</a></li>
//         <li><a href="#">Privacy Policy</a></li>
//         <li><a href="#">Refund Policy</a></li>
//         <li><a href="#">Shipping & Delivery</a></li>
//       </ul>
//     </div>

//     <div className="footer-contact">
//       <h4>Keep In Touch</h4>
//       {/* <p><strong>Office Address:</strong><br />East Delhi, New Delhi - 110092</p> */}
//       <p><strong>Contact Number:</strong><br />+91 7710036965</p>
//       <p><strong>Email Address:</strong><br /><a href="mailto:revampspaces.in@gmail.com">revampspaces.in@gmail.com</a></p>
//     </div>
//   </div>

//   <div className="footer-bottom">
//     <p>© 2025 RevampSpaces | AI-Powered Interior Design</p>
//   </div>

//   {/* Cookie Consent Bar */}
//   {/* <div className="cookie-consent">
//     <p>By clicking "Accept all cookies", you agree RevampSpaces can store cookies on your device and disclose information in accordance with our Privacy Policy.</p>
//     <div className="cookie-buttons">
//       <button className="accept">Accept all</button>
//       <button className="reject">Reject all</button>
//       <button className="manage">Manage preferences</button>
//     </div>
//   </div> */}
// </footer>
//     </div>
//   );
// }

// export default App;

// import React, { useState, useEffect, useRef } from 'react';
// import './App.css';

// const NAV_LINKS = ['About', 'Publications', 'Testimonials', 'Subscribe'];

// function useInView(threshold = 0.15) {
//   const ref = useRef(null);
//   const [inView, setInView] = useState(false);
//   useEffect(() => {
//     const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setInView(true); }, { threshold });
//     if (ref.current) obs.observe(ref.current);
//     return () => obs.disconnect();
//   }, []);
//   return [ref, inView];
// }

// function Navbar() {
//   const [scrolled, setScrolled] = useState(false);
//   const [menuOpen, setMenuOpen] = useState(false);
//   useEffect(() => {
//     const fn = () => setScrolled(window.scrollY > 40);
//     window.addEventListener('scroll', fn);
//     return () => window.removeEventListener('scroll', fn);
//   }, []);
//   const scrollTo = (id) => {
//     document.getElementById(id.toLowerCase())?.scrollIntoView({ behavior: 'smooth' });
//     setMenuOpen(false);
//   };
//   return (
//     <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
//       <div className="navbar__brand" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
//         <span className="navbar__logo-text">समय की चर्चा</span>
//         <span className="navbar__divider">×</span>
//         <span className="navbar__logo-sub">StarTeller</span>
//       </div>
//       <div className={`navbar__links ${menuOpen ? 'navbar__links--open' : ''}`}>
//         {NAV_LINKS.map(l => (
//           <button key={l} className="navbar__link" onClick={() => scrollTo(l)}>{l}</button>
//         ))}
//         <button className="navbar__cta" onClick={() => scrollTo('Subscribe')}>Subscribe Now</button>
//       </div>
//       <button className="navbar__burger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
//         <span className={menuOpen ? 'open' : ''}></span>
//         <span className={menuOpen ? 'open' : ''}></span>
//         <span className={menuOpen ? 'open' : ''}></span>
//       </button>
//     </nav>
//   );
// }

// function Hero() {
//   return (
//     <section className="hero" id="hero">
//       <div className="hero__noise"></div>
//       <div className="hero__date-bar">
//         <span>{new Date().toLocaleDateString('hi-IN', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</span>
//         <span>Vol. I · Issue 1</span>
//       </div>
//       <div className="hero__content">
//         <div className="hero__eyebrow">समाचार · Magazine · Press</div>
//         <h1 className="hero__headline">
//           <span className="hero__headline-line hero__headline-line--1">सच की</span>
//           <span className="hero__headline-line hero__headline-line--2">आवाज़,</span>
//           <span className="hero__headline-line hero__headline-line--3">सितारों</span>
//           <span className="hero__headline-line hero__headline-line--4">की कहानी।</span>
//         </h1>
//         <p className="hero__sub">Two publications. One truth. Delivered to your doorstep.</p>
//         <div className="hero__actions">
//           <button className="btn btn--primary" onClick={() => document.getElementById('subscribe').scrollIntoView({ behavior: 'smooth' })}>
//             Start Subscribing
//           </button>
//           <button className="btn btn--ghost" onClick={() => document.getElementById('publications').scrollIntoView({ behavior: 'smooth' })}>
//             Explore Publications ↓
//           </button>
//         </div>
//       </div>
//       <div className="hero__marquee-wrap">
//         <div className="hero__marquee">
//           {Array(3).fill('समय की चर्चा · StarTeller · Local News · Astrology & Lifestyle · Hindi Press · ').join('').split('').map((c, i) => <span key={i}>{c}</span>)}
//         </div>
//       </div>
//       <div className="hero__scroll-hint">scroll ↓</div>
//     </section>
//   );
// }

// function About() {
//   const [ref, inView] = useInView();
//   return (
//     <section className="about section" id="about" ref={ref}>
//       <div className={`about__inner container ${inView ? 'fade-in' : ''}`}>
//         <div className="about__label section-label">About Us</div>
//         <div className="about__grid">
//           <div className="about__left">
//             <h2 className="about__heading">हम सिर्फ समाचार नहीं,<br />एक आंदोलन हैं।</h2>
//           </div>
//           <div className="about__right">
//             <p className="about__body">
//               Founded with a belief that local voices deserve a global stage, our publishing house brings you two distinct titles — each with its own identity, audience, and purpose.
//             </p>
//             <p className="about__body">
//               <strong>समय की चर्चा</strong> is your trusted Hindi daily, rooted in grassroots journalism that speaks the language of the people. <strong>StarTeller</strong> is our lifestyle and astrology magazine — a beautifully designed monthly that guides you through the cosmos and culture.
//             </p>
//             <div className="about__stats">
//               <div className="about__stat"><span className="about__stat-num">12+</span><span className="about__stat-label">Years of Publishing</span></div>
//               <div className="about__stat"><span className="about__stat-num">50K+</span><span className="about__stat-label">Subscribers</span></div>
//               <div className="about__stat"><span className="about__stat-num">2</span><span className="about__stat-label">Iconic Titles</span></div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// function Publications() {
//   const [ref, inView] = useInView();
//   return (
//     <section className="publications section" id="publications" ref={ref}>
//       <div className={`container ${inView ? 'fade-in' : ''}`}>
//         <div className="section-label">Our Publications</div>
//         <h2 className="section-heading">Two Worlds.<br />One Publisher.</h2>
//         <div className="pub__grid">
//           <div className="pub__card pub__card--news">
//             <div className="pub__card-tag">Hindi Daily · Since 2012</div>
//             <div className="pub__card-title-hindi">समय की चर्चा</div>
//             <div className="pub__card-title-en">Samay Ki Charcha</div>
//             <p className="pub__card-desc">
//               A hard-hitting Hindi newspaper covering local politics, crime, business, and community stories. Published every morning — bold headlines, fearless reporting.
//             </p>
//             <ul className="pub__card-features">
//               <li>Daily morning edition</li>
//               <li>Local & regional coverage</li>
//               <li>Investigative journalism</li>
//               <li>Community voices section</li>
//             </ul>
//             <div className="pub__card-price">From ₹99 / month</div>
//           </div>

//           <div className="pub__card pub__card--mag">
//             <div className="pub__card-tag">Lifestyle Magazine · Monthly</div>
//             <div className="pub__card-title-en pub__card-title-star">StarTeller</div>
//             <div className="pub__card-subtitle">स्टारटेलर</div>
//             <p className="pub__card-desc">
//               A premium monthly magazine blending astrology, horoscopes, wellness, and lifestyle. Beautifully printed, thoughtfully curated — a treat for mind and soul.
//             </p>
//             <ul className="pub__card-features">
//               <li>Monthly print edition</li>
//               <li>In-depth horoscopes</li>
//               <li>Lifestyle & wellness features</li>
//               <li>Celebrity astro interviews</li>
//             </ul>
//             <div className="pub__card-price">From ₹149 / month</div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// const TESTIMONIALS = [
//   { name: 'Priya Sharma', location: 'Lucknow, UP', pub: 'समय की चर्चा', text: 'मैं पिछले 5 सालों से समय की चर्चा पढ़ रही हूं। यह अखबार हमारी आवाज़ है।' },
//   { name: 'Rajesh Verma', location: 'Bhopal, MP', pub: 'StarTeller', text: 'StarTeller has completely changed how I plan my month. The horoscopes are eerily accurate and the lifestyle section is just gorgeous.' },
//   { name: 'Anita Joshi', location: 'Jaipur, Rajasthan', pub: 'Both', text: 'The combo subscription is a steal. I get my morning news fix and my monthly cosmic guide — can\'t imagine life without both.' },
//   { name: 'Devendra Patel', location: 'Surat, Gujarat', pub: 'समय की चर्चा', text: 'Fearless, honest, and local. समय की चर्चा reports the stories nobody else dares to touch.' },
// ];

// function Testimonials() {
//   const [ref, inView] = useInView();
//   const [active, setActive] = useState(0);
//   useEffect(() => {
//     const t = setInterval(() => setActive(a => (a + 1) % TESTIMONIALS.length), 4000);
//     return () => clearInterval(t);
//   }, []);
//   const t = TESTIMONIALS[active];
//   return (
//     <section className="testimonials section" id="testimonials" ref={ref}>
//       <div className={`container ${inView ? 'fade-in' : ''}`}>
//         <div className="section-label">Readers Say</div>
//         <div className="testimonials__stage">
//           <div className="testimonials__quote-mark">"</div>
//           <div className="testimonials__text" key={active}>{t.text}</div>
//           <div className="testimonials__meta">
//             <span className="testimonials__name">{t.name}</span>
//             <span className="testimonials__loc">{t.location}</span>
//             <span className="testimonials__pub">{t.pub}</span>
//           </div>
//           <div className="testimonials__dots">
//             {TESTIMONIALS.map((_, i) => (
//               <button key={i} className={`testimonials__dot ${i === active ? 'active' : ''}`} onClick={() => setActive(i)} />
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// const PLANS = [
//   {
//     id: 'samay-monthly',
//     label: 'समय की चर्चा',
//     badge: '',
//     period: 'Monthly',
//     price: '₹99',
//     per: '/month',
//     features: ['Daily print edition', 'Local news coverage', 'ePaper access', 'Cancel anytime'],
//   },
//   {
//     id: 'samay-yearly',
//     label: 'समय की चर्चा',
//     badge: 'Best Value',
//     period: 'Yearly',
//     price: '₹999',
//     per: '/year',
//     features: ['All monthly features', '2 months free', 'Priority delivery', 'Annual digest book'],
//   },
//   {
//     id: 'star-monthly',
//     label: 'StarTeller',
//     badge: '',
//     period: 'Monthly',
//     price: '₹149',
//     per: '/month',
//     features: ['Monthly print edition', 'Digital PDF access', 'Horoscope updates', 'Cancel anytime'],
//   },
//   {
//     id: 'star-yearly',
//     label: 'StarTeller',
//     badge: 'Popular',
//     period: 'Yearly',
//     price: '₹1,499',
//     per: '/year',
//     features: ['All monthly features', '2 months free', 'Exclusive wall calendar', 'VIP reader events'],
//   },
//   {
//     id: 'combo',
//     label: 'Combo Bundle',
//     badge: '🔥 Best Deal',
//     period: 'Yearly',
//     price: '₹1,999',
//     per: '/year',
//     features: ['समय की चर्चा (yearly)', 'StarTeller (yearly)', 'Save ₹499', 'Free gift subscription'],
//   },
// ];

// function Subscribe() {
//   const [ref, inView] = useInView();
//   const [selectedPlan, setSelectedPlan] = useState('');
//   const [form, setForm] = useState({ name: '', email: '', phone: '', address: '' });
//   const [submitted, setSubmitted] = useState(false);
//   const [errors, setErrors] = useState({});

//   const validate = () => {
//     const e = {};
//     if (!form.name.trim()) e.name = 'Name is required';
//     if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = 'Valid email required';
//     if (!/^\d{10}$/.test(form.phone.replace(/\s/g, ''))) e.phone = '10-digit phone required';
//     if (!selectedPlan) e.plan = 'Please select a plan';
//     return e;
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const errs = validate();
//     if (Object.keys(errs).length) { setErrors(errs); return; }
//     setSubmitted(true);
//   };

//   return (
//     <section className="subscribe section" id="subscribe" ref={ref}>
//       <div className={`container ${inView ? 'fade-in' : ''}`}>
//         <div className="section-label">Subscribe</div>
//         <h2 className="section-heading">Choose Your Plan</h2>

//         {errors.plan && <div className="subscribe__plan-error">{errors.plan}</div>}
//         <div className="plans__grid">
//           {PLANS.map(plan => (
//             <div
//               key={plan.id}
//               className={`plan__card ${selectedPlan === plan.id ? 'plan__card--selected' : ''} ${plan.badge ? 'plan__card--featured' : ''}`}
//               onClick={() => { setSelectedPlan(plan.id); setErrors(prev => ({ ...prev, plan: '' })); }}
//             >
//               {plan.badge && <div className="plan__badge">{plan.badge}</div>}
//               <div className="plan__pub">{plan.label}</div>
//               <div className="plan__period">{plan.period}</div>
//               <div className="plan__price">{plan.price}<span className="plan__per">{plan.per}</span></div>
//               <ul className="plan__features">
//                 {plan.features.map(f => <li key={f}><span className="plan__check">✓</span>{f}</li>)}
//               </ul>
//               <div className="plan__select-indicator">{selectedPlan === plan.id ? '● Selected' : 'Select'}</div>
//             </div>
//           ))}
//         </div>

//         {!submitted ? (
//           <form className="subscribe__form" onSubmit={handleSubmit} noValidate>
//             <h3 className="subscribe__form-title">Your Details</h3>
//             <div className="form__row">
//               <div className="form__group">
//                 <label>Full Name *</label>
//                 <input type="text" placeholder="Rajesh Kumar" value={form.name}
//                   onChange={e => setForm({ ...form, name: e.target.value })} className={errors.name ? 'error' : ''} />
//                 {errors.name && <span className="form__error">{errors.name}</span>}
//               </div>
//               <div className="form__group">
//                 <label>Email Address *</label>
//                 <input type="email" placeholder="you@example.com" value={form.email}
//                   onChange={e => setForm({ ...form, email: e.target.value })} className={errors.email ? 'error' : ''} />
//                 {errors.email && <span className="form__error">{errors.email}</span>}
//               </div>
//             </div>
//             <div className="form__row">
//               <div className="form__group">
//                 <label>Phone Number *</label>
//                 <input type="tel" placeholder="98XXXXXXXX" value={form.phone}
//                   onChange={e => setForm({ ...form, phone: e.target.value })} className={errors.phone ? 'error' : ''} />
//                 {errors.phone && <span className="form__error">{errors.phone}</span>}
//               </div>
//               <div className="form__group">
//                 <label>Delivery Address</label>
//                 <input type="text" placeholder="Street, City, State, PIN" value={form.address}
//                   onChange={e => setForm({ ...form, address: e.target.value })} />
//               </div>
//             </div>
//             <button type="submit" className="btn btn--primary btn--full">
//               Confirm Subscription →
//             </button>
//           </form>
//         ) : (
//           <div className="subscribe__success">
//             <div className="subscribe__success-icon">✓</div>
//             <h3>आपकी subscription confirm हो गई!</h3>
//             <p>Thank you, <strong>{form.name}</strong>! You've subscribed to <strong>{PLANS.find(p => p.id === selectedPlan)?.label}</strong> ({PLANS.find(p => p.id === selectedPlan)?.period}). We'll reach out on {form.email} within 24 hours.</p>
//             <button className="btn btn--ghost" onClick={() => { setSubmitted(false); setForm({ name: '', email: '', phone: '', address: '' }); setSelectedPlan(''); }}>Subscribe Another</button>
//           </div>
//         )}
//       </div>
//     </section>
//   );
// }

// function Footer() {
//   return (
//     <footer className="footer">
//       <div className="footer__top container">
//         <div className="footer__brand">
//           <div className="footer__logo">समय की चर्चा × StarTeller</div>
//           <p className="footer__tagline">Truthful news. Cosmic perspective.</p>
//         </div>
//         <div className="footer__links">
//           <div className="footer__col">
//             <div className="footer__col-title">Publications</div>
//             <a href="#publications">समय की चर्चा</a>
//             <a href="#publications">StarTeller Magazine</a>
//             <a href="#subscribe">Combo Bundle</a>
//           </div>
//           <div className="footer__col">
//             <div className="footer__col-title">Company</div>
//             <a href="#about">About Us</a>
//             <a href="#testimonials">Reader Stories</a>
//             <a href="#subscribe">Subscribe</a>
//           </div>
//           <div className="footer__col">
//             <div className="footer__col-title">Contact</div>
//             <a href="mailto:hello@samaypress.in">hello@samaypress.in</a>
//             <a href="tel:+919800000000">+91 98000 00000</a>
//             <span>Mumbai, Maharashtra</span>
//           </div>
//         </div>
//       </div>
//       <div className="footer__bottom container">
//         <span>© {new Date().getFullYear()} Samay Press. All rights reserved.</span>
//         <span>Designed with ♥ for Hindi readers.</span>
//       </div>
//     </footer>
//   );
// }

// export default function App() {
//   return (
//     <div className="app">
//       <Navbar />
//       <Hero />
//       <About />
//       <Publications />
//       <Testimonials />
//       <Subscribe />
//       <Footer />
//     </div>
//   );
// }


// import React, { useState } from 'react';
// import './App.css';
// import Navbar from './components/Navbar';
// import Hero from './components/Hero';
// import AboutSection from './components/AboutSection';
// import GallerySection from './components/GallerySection';
// import EquipmentSection from './components/EquipmentSection';
// import ReviewsSection from './components/ReviewsSection';
// import LocationSection from './components/LocationSection';
// import MembershipForm from './components/MembershipForm';
// import Footer from './components/Footer';

// function App() {
//   const [showForm, setShowForm] = useState(false);

//   return (
//     <div className="App">
//       <Navbar onFormOpen={() => setShowForm(true)} />
//       <Hero onFormOpen={() => setShowForm(true)} />
//       <AboutSection />
//       <GallerySection />
//       <EquipmentSection />
//       <ReviewsSection />
//       <LocationSection />
//       <Footer />
//       {showForm && <MembershipForm onClose={() => setShowForm(false)} />}
//     </div>
//   );
// }

// export default App;


import React, { useState } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import GallerySection from './components/GallerySection';
import EquipmentSection from './components/EquipmentSection';
import ReviewsSection from './components/ReviewsSection';
import LocationSection from './components/LocationSection';
import MembershipForm from './components/MembershipForm';
import Footer from './components/Footer';
import { GymProvider } from './context/GymContext'; // ✅ ADD THIS
import WhatsAppButton from './components/WhatsAppButton';
import SocialButtons from './components/SocialButtons';
import '@fortawesome/fontawesome-free/css/all.min.css';

function App() {
  const [showForm, setShowForm] = useState(false);

  return (
    <GymProvider> {/* ✅ WRAP EVERYTHING */}
      <div className="App">
        <Navbar onFormOpen={() => setShowForm(true)} />
        <Hero onFormOpen={() => setShowForm(true)} />
        <AboutSection />
        <GallerySection />
        <EquipmentSection />
        <ReviewsSection />
        <LocationSection />
        <Footer />
        <SocialButtons />
        {showForm && <MembershipForm onClose={() => setShowForm(false)} />}
      </div>
    </GymProvider>
  );
}

export default App;